if (!Object.assign) {
    Object.assign = function () {
        var resObj = {};
        for (var i = 0; i < arguments.length; i += 1) {
            var obj = arguments[i];

            if (typeof obj === 'object') {
                keys = Object.keys(obj);

                for (var j = 0; j < keys.length; j += 1) {
                    resObj[keys[j]] = obj[keys[j]];
                }
            }
        }
        return resObj;
    };
}
